import { HostActionType as e } from "../types/HostActionType.mjs";
import { HostActionIntent as t } from "../types/HostActionIntent.mjs";
import { HostActionFacetKind as n } from "../types/HostActionFacet.mjs";
import { HostActionTargetKind as r } from "../types/HostActionTarget.mjs";
import { VerificationStatus as i } from "@maat/api-main/types";
//#region src/mappers/toVerificationActions.ts
var a = new Set([i.Unverified, i.Rejected]), o = (o, s) => !s || !a.has(s.status) ? [] : [{
	id: `${e.VerificationRequired}:${o}`,
	type: e.VerificationRequired,
	intent: t.Blocker,
	params: { variant: `${o}_${s.status}` },
	facets: s.status === i.Rejected && s.rejection_reason ? [{
		kind: n.Text,
		text: s.rejection_reason
	}] : void 0,
	target: { kind: r.WorkspaceVerification }
}];
//#endregion
export { o as toVerificationActions };
